export interface StripeProduct {
  id: string;
  name: string;
  description: string;
  price: number; // Price in dollars
  mode: 'payment' | 'subscription';
}

export const STRIPE_PRODUCTS: StripeProduct[] = [
  {
    id: 'extra_small_frame',
    name: 'Extra Small Frame Test',
    description: 'Extra small size framed print',
    price: 59.50,
    mode: 'payment'
  },
  {
    id: 'small_frame',
    name: 'Small Frame Test',
    description: 'Small size framed print of your home',
    price: 79.50,
    mode: 'payment'
  },
  {
    id: 'medium_frame',
    name: 'Medium Frame Test',
    description: 'Medium size framed print of your home',
    price: 119.50,
    mode: 'payment'
  },
  {
    id: 'large_frame',
    name: 'Large Frame Test',
    description: 'Large size framed print of your home',
    price: 149.50,
    mode: 'payment'
  }
];

// Helper function to get product by ID
export function getProductById(id: string): StripeProduct | undefined {
  return STRIPE_PRODUCTS.find(product => product.id === id);
}

// Helper function to get product by size
export function getProductBySize(size: 'XS' | 'S' | 'M' | 'L'): StripeProduct | undefined {
  const sizeMap = {
    'XS': 'extra_small_frame',
    'S': 'small_frame',
    'M': 'medium_frame', 
    'L': 'large_frame'
  };
  
  return STRIPE_PRODUCTS.find(product => product.id === sizeMap[size]);
}

// Helper function to get product by price ID (for webhook compatibility)
export function getProductByPriceId(priceId: string): StripeProduct | undefined {
  // This is for backward compatibility with webhooks
  // We'll try to match based on the price amount or other identifying info
  return STRIPE_PRODUCTS[1]; // Default to medium for now
}